import { NotificationSource } from '../../../client/source';
import { StoredApplicationMap, StoredStreamMap } from '../../store/State';

/**
 * Returns the UUID of the application associated with this notification source.
 *
 * Will be `null` if there no associated application, or if the associated application cannot be found in the cached
 * application details store.
 */
export function getSourceApp(source: NotificationSource): string | null {
  if (source.type === 'desktop') {
    return source.identity.uuid;
  }
  return null;
}

export function getApplicationTitle(uuid: string, applications: StoredApplicationMap): string {
  return applications.get(uuid)?.title ?? '';
}

/**
 * Returns a user-facing description of a notification source.
 */
export function getSourceTitle(
  source: NotificationSource,
  applications: StoredApplicationMap
): string {
  if (source.type === 'desktop') {
    return applications.get(source.identity.uuid)?.title || source.identity.name || '';
  } else {
    return '';
  }
}

/**
 * Returns a user-facing description of a notification from its stream data.
 */
export function getStreamTitle(
  streams: StoredStreamMap,
  streamId: string | undefined
): string | undefined {
  if (streamId !== undefined) {
    const streamTitle = streams.get(streamId)?.displayName;
    if (streamTitle) {
      return streamTitle;
    }
  }
  return undefined;
}
